export { default, getIconedDetail, getLabel } from "./IconedDetail";
